import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';

import { WsLimit } from '../wslimit/wslimit.service';

import { Fmt } from '../../fmt.service';

@Injectable()
export class WsSettingDialogService {
    constructor(
        private _http: Http,
        public _fmt: Fmt,
    ) {}

    GetWorkspaceDetails<T>() {
        var params = new URLSearchParams();

        return this._fmt.HttpGet<T>('/api/v1/get_workspace_details', params);
    }

    SaveSingleWSUsageUpdate(wsUsage: any): Observable<Response> {
        return this._fmt.HttpPost('/api/v1/update_current_limits', wsUsage);
    }

    UpdateWorkspaceLimitsSettings(wsUsage: any): Observable<Response> {
        return this._fmt.HttpPost('/api/v1/update_workspace_limits_settings', wsUsage);
    }

    GetWsLimits<T>(): Observable<T> {
        var params = new URLSearchParams();

        return this._fmt.HttpGet<T>('/api/v1/get_ws_limits');
    }

    PostSaveWsUsageDefaults(wsLimit: WsLimit): Observable<Response> {
        return this._fmt.HttpPost('/api/v1/post_save_ws_usage_defaults', wsLimit);
    }

    GetWorkspacePlans<T>() {
        var params = new URLSearchParams();

        return this._fmt.HttpGet<T>('/api/v1/get_workspace_plans', params);
    }

    CreateWorkspaceForAdmin(wsLimit: WsLimit): Observable<CreateWorkspaceResult> {
        return this._fmt.HttpPost('/api/v1/create_workspace_for_admin', wsLimit);
    }

    GetURLWhitelists<T>(params: any): Observable<T> {
        return this._fmt.HttpGet<T>('/api/v1/get_urlwhitelists', params);
    }

    GetIPAddrWhitelists<T>(params: any): Observable<T> {
        return this._fmt.HttpGet<T>('/api/v1/get_ipaddr_whitelists', params);
    }

    PostUpdateURLWhitelist(urls: any) {
        return this._fmt.HttpPost('/api/v1/post_bulkupdate_urlwhitelist', urls);
    }

    PostUpdateIPAddrWhitelist(urls: any) {
        return this._fmt.HttpPost('/api/v1/post_bulkupdate_ipaddrwhitelist', urls);
    }

    PostEnableWSIPFilter(payload: any) {
        return this._fmt.HttpPost('/api/v1/post_enable_wsipfilter', payload);
    }

    GetProjectLists<T>(params: any): Observable<T> {
        return this._fmt.HttpGet<T>('/api/v1/get_project_list', params);
    }

    PostUpdateProjectMode<T>(payload: any): Observable<T> {
        return this._fmt.HttpPost<T>('/api/v1/post_update_project_mode', payload);
    }
}

export interface WsSettingList {
    Columns: string[];
}

export interface CreateWorkspaceResult {
    w_id: string;
}
